export const teamMembers = [
  {
    id: 1,
    firstName: 'Екатерина',
    lastName: 'Сацура',
    role: 'Mentor',
    photo: '/aboutUs/satsura.jpg',
    github: 'ksatsura',
  },
  {
    id: 2,
    firstName: 'Андрей',
    lastName: 'Барышев',
    role: 'Backend sync, Sprint',
    photo: '/aboutUs/baryshev.jpg',
    github: 'chebb44',
  },
  {
    id: 3,
    firstName: 'Вероника',
    lastName: 'Мартинович',
    role: 'Learning, Statistic',
    photo: '/aboutUs/martinovich.jpg',
    github: 'veronika-martinovich',
  },
  {
    id: 4,
    firstName: 'Игорь',
    lastName: 'Буренко',
    role: 'SpeakIt, Dictionary',
    photo: '/aboutUs/burenko.jpg',
    github: 'igorburenko',
  },
  {
    id: 5,
    firstName: 'Владимир',
    lastName: 'Луговцов',
    role: 'AudioCall, Quiz, Puzzle',
    photo: '/aboutUs/lugovczov.jpg',
    github: 'lugovczov',
  },
  {
    id: 6,
    firstName: 'Константин',
    lastName: 'Котов',
    role: 'Savanna',
    photo: '/aboutUs/kotov.jpg',
    github: 'Kostanios',
  },
];
